import { decode } from 'html-entities';
import dayjs from 'dayjs';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
// Utils and helpers
import { numberFormat } from 'helpers/i18n';
// Assets
import NoTransactions from '../../assets/bitcoinRewardsSection/NoTransactions.svg';
import useStyles from './styles';

const columns = [
    {
        id: 'cardName',
        label: 'USER',
        minWidth: 30,
        align: 'left'
    },
    { id: 'createdAt', label: 'DATE', minWidth: 150, align: 'left' },

    { id: 'cardLabel', label: 'CARD NAME', minWidth: 150, align: 'left' },
    {
        id: 'transactionAmount',
        label: 'TRANSACTION AMOUNT',
        minWidth: 100,
        align: 'left'
    },
    {
        id: 'points',
        label: 'Reward points',
        minWidth: 100,
        align: 'left',
        fontWeight: 'bold'
    }
];

export default function TableEarned({ rewards, pagination, setPagination }) {
    const classes = useStyles();

    const formatData = (data, property) => {
        switch (property) {
            case 'createdAt':
                return data ? dayjs(data).format('MMM DD, YYYY') : '';
            case 'cardLabel':
                return data;
            case 'transactionAmount':
                const amountInDollars = data / 100;
                return `${numberFormat(amountInDollars, 2, 2)}`;
            case 'points':
                return new Intl.NumberFormat().format(data);
            case 'cardName':
                return data;
            default:
        }
    };

    const handlePageChange = (event, newPage) => {
        setPagination({ ...pagination, page: newPage });
    };

    const handleRowsPerPageChange = event => {
        setPagination({
            page: 0,
            rowsPerPage: Number(event?.target?.value)
        });
    };

    return (
        <Paper
            sx={{
                width: '97%',
                overflow: 'hidden',
                marginTop: '21px',
                overflowY: 'hidden'
            }}>
            <TableContainer sx={{ maxHeight: 700 }}>
                <Table stickyHeader aria-label="sticky table">
                    <TableHead sx={{ position: 'relative', zIndex: 1 }}>
                        <TableRow>
                            {columns.map(column => (
                                <TableCell
                                    className={classes.headerTableCell}
                                    key={column.id}
                                    align={rewards.results.length === 0 ? 'center' : column.align}
                                    style={{
                                        minWidth: column.minWidth,
                                        width: column.minWidth,
                                        fontWeight: 'bold',
                                        fontSize: '14px',
                                        lineHeight: '17px',
                                        color: '#A8B6C1',
                                        backgroundColor: '#F1F3F7',
                                        height: '50px',
                                        textTransform: 'uppercase',
                                        paddingLeft: rewards.results.length > 0 && column.label === 'USER' && '3em'
                                    }}>
                                    {column.label}
                                </TableCell>
                            ))}
                        </TableRow>
                    </TableHead>
                    {
                        <TableBody
                            style={{
                                overflowY: 'hidden',
                                height: rewards.results.length === 0 && '600px'
                            }}>
                            {!!rewards.results.length &&
                                rewards.results.map(reward => {
                                    return (
                                        <TableRow role="checkbox" tabIndex={-1} key={reward.id}>
                                            {columns.map(column => {
                                                const value = reward[column.id];
                                                return (
                                                    <TableCell
                                                        className={classes.textRowPrimary}
                                                        key={column.id}
                                                        align={column.align}
                                                        sx={{
                                                            maxHeight: '66px',
                                                            p: 0,
                                                            paddingLeft:
                                                                rewards.results.length > 0 && column.id === 'cardName'
                                                                    ? '3.3em'
                                                                    : '1.3em'
                                                        }}
                                                        style={{
                                                            fontWeight:
                                                                column.id === 'cardName'
                                                                    ? 600
                                                                    : column.id === 'rewards'
                                                                    ? 700
                                                                    : column.id === 'points'
                                                                    ? 'bold'
                                                                    : 500,
                                                            height: '66px !important'
                                                        }}>
                                                        {column.id !== 'cardName' ? (
                                                            <label>{formatData(value, column.id)}</label>
                                                        ) : (
                                                            <label>{reward?.cardName}</label>
                                                        )}
                                                        {column.id === 'cardName' && (
                                                            <span
                                                                style={{
                                                                    fontWeight: 500,
                                                                    fontSize: '13px',
                                                                    lineHeight: '20px',
                                                                    color: '#7D95A5'
                                                                }}>
                                                                <br />*{reward?.cardLast4}
                                                            </span>
                                                        )}
                                                        {column.id === 'cardLabel' && (
                                                            <span
                                                                style={{
                                                                    fontWeight: 500,
                                                                    fontSize: '13px',
                                                                    lineHeight: '20px'
                                                                }}>
                                                                {decode(reward?.cardLabel, { level: 'html5' })}
                                                            </span>
                                                        )}
                                                    </TableCell>
                                                );
                                            })}
                                        </TableRow>
                                    );
                                })}
                            {rewards.results.length === 0 && (
                                <TableRow>
                                    <TableCell colSpan={5} sx={{ textAlign: 'center' }}>
                                        <img src={NoTransactions} alt={'no-transactions'} />
                                    </TableCell>
                                </TableRow>
                            )}
                        </TableBody>
                    }
                </Table>
            </TableContainer>
            <TablePagination
                rowsPerPageOptions={[5, 10, 25, 100]}
                component="div"
                count={rewards.total}
                rowsPerPage={pagination.rowsPerPage}
                page={pagination.page}
                onPageChange={handlePageChange}
                onRowsPerPageChange={handleRowsPerPageChange}
            />
        </Paper>
    );
}
